<div class="layout-menu-container"><h-submenu class="layout-menu" :items="model" :root="true" @item-click="onItemClick"></h-submenu></div>